import { openBlock as o, createBlock as s, Transition as a, withCtx as r, withDirectives as l, createElementVNode as n, normalizeClass as d, renderSlot as c, vShow as i } from "vue";
/* empty css                    */
import f from "./design-system.es128.js";
const u = {
  name: "DsTrowser",
  props: {
    show: { type: Boolean, default: !1 },
    absolute: { type: Boolean, default: !1 }
  }
};
function p(t, m, e, _, w, h) {
  return o(), s(a, {
    name: "slide-up",
    class: "trowser"
  }, {
    default: r(() => [
      l(n("div", {
        class: d(["trowser-bar", { absolute: e.absolute }])
      }, [
        c(t.$slots, "default", {}, void 0, !0)
      ], 2), [
        [i, e.show]
      ])
    ]),
    _: 3
  });
}
const x = /* @__PURE__ */ f(u, [["render", p], ["__scopeId", "data-v-2dda2eb9"]]);
export {
  x as default
};
//# sourceMappingURL=design-system.es115.js.map
